var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useMemo } from 'react';
import { Column, FilterRow, SearchPanel, } from 'devextreme-react/data-grid';
import { DataGrid, Template } from 'devextreme-react';
import { Paper, useMediaQuery, useTheme } from '@material-ui/core';
import { IconButton } from '@michelin/acid-components';
import ChangelogCell from '../ChangelogCell/ChangelogCell';
import { useChangeLog } from '../../hooks/useChangelog';
import { Refresh, CloudDownload } from '@material-ui/icons';
import moment from 'moment';
import { RemoteFilterGroupRenderer } from '@michelin/acid-components';
import { ChangelogContextProvider } from './ChangelogContext';
import { CentralProviderContext, useTranslation } from '@michelin/central-provider';
import { DefaultsColumns } from '../../utilities/defaults';
import { ExportToCsv } from 'export-to-csv';
export default function (_a) {
    var _b;
    var config = _a.config, app = _a.app, entity = _a.entity, identifier = _a.identifier, dictionary = _a.dictionary, api = _a.api, except = _a.except, height = _a.height, paperHeight = _a.paperHeight, timeZone = _a.timeZone, allowExport = _a.allowExport, csvOptions = _a.csvOptions, onExportError = _a.onExportError;
    var t = useTranslation().t;
    var providerContext = useContext(CentralProviderContext);
    var _c = config.columns, columns = _c === void 0 ? DefaultsColumns(t) : _c, _d = config.filters, filters = _d === void 0 ? {} : _d, filterGroup = config.filterGroup;
    var APP = providerContext.application || app || '';
    var theme = useTheme();
    var phoneView = useMediaQuery(theme.breakpoints.down('xs'));
    var options = __assign({ fieldSeparator: ',', quoteStrings: '"', decimalSeparator: '.', showLabels: true, showTitle: true, title: 'Exported CSV', useTextFile: false, useBom: true, useKeysAsHeaders: true, filename: (_b = csvOptions === null || csvOptions === void 0 ? void 0 : csvOptions.title) !== null && _b !== void 0 ? _b : 'Exported CSV' }, csvOptions);
    var csvExporter = useMemo(function () {
        return new ExportToCsv(options);
    }, [csvOptions]);
    var renderRefreshBtn = function () { return (React.createElement(IconButton, { size: "medium", onClick: function () { return changeLogQuery.dataSource.reload(); } },
        React.createElement(Refresh, null))); };
    var renderResultsCounter = function () { return (React.createElement("i", null, changeLogQuery.resultsCounter() > -1 ? ((!phoneView ? t('Listing') : '') + t(' {{resultsCount}} records', {
        resultsCount: changeLogQuery.resultsCounter(),
    })) : t('Loading...'))); };
    var onToolbarPreparing = function (e) {
        var itemLocation = phoneView ? 'before' : 'after';
        e.toolbarOptions.items.unshift({
            location: itemLocation,
            template: 'resultsCounter',
        });
        e.toolbarOptions.items.push({
            location: itemLocation,
            template: 'refreshData',
        });
        e.toolbarOptions.items.push({
            location: itemLocation,
            template: 'exportCsv',
        });
        if (config.filterGroup && config.filterGroup.filters.length) {
            e.toolbarOptions.items.unshift({
                location: 'before',
                template: 'filterFields',
            });
        }
    };
    var renderFilterFields = function () { return (filterGroup ? React.createElement(RemoteFilterGroupRenderer, { filterGroup: filterGroup }) : null); };
    Object.keys(filters).forEach(function (key) {
        var value = filters[key];
        if (value === undefined || value === '') {
            delete filters[key];
        }
        else {
            var reg = /^(19|20|21)\d\d[/](0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])$/;
            if (reg.test(value))
                filters[key] = moment(value).format();
        }
    });
    // If there is no filters, we must send the entity to retrive the data.
    if (!filters.entity)
        filters['entity'] = entity;
    var changeLogQuery = useChangeLog(api, APP, entity, identifier, except, filters, config.ignore);
    var renderExportBtn = function () {
        if (!allowExport)
            return null;
        return (React.createElement(IconButton, { size: "medium", onClick: function () {
                var _a;
                try {
                    var columnFields_1 = {};
                    (_a = config.columns) === null || _a === void 0 ? void 0 : _a.forEach(function (col) {
                        columnFields_1[col.field] = col.caption;
                    });
                    var data = changeLogQuery.dataSource.items().map(function (item) {
                        var _a;
                        var newItem = {};
                        (_a = Object.keys(columnFields_1 !== null && columnFields_1 !== void 0 ? columnFields_1 : {})) === null || _a === void 0 ? void 0 : _a.forEach(function (field) {
                            newItem[columnFields_1[field]] = typeof item[field] === 'object'
                                ? JSON.stringify(item[field])
                                : item[field];
                        });
                        return newItem;
                    });
                    csvExporter.generateCsv(data);
                }
                catch (e) {
                    if (onExportError) {
                        onExportError(e);
                    }
                }
            } },
            React.createElement(CloudDownload, null)));
    };
    return (React.createElement(ChangelogContextProvider, { ignore: config.ignore, dictionary: dictionary },
        React.createElement(Paper, { style: { height: paperHeight } },
            React.createElement(DataGrid, __assign({ dataSource: changeLogQuery.dataSource, remoteOperations: true, noDataText: 'No data', className: "freespaced-table " + (phoneView ? 'phone-view' : ''), scrolling: { mode: 'virtual', rowRenderingMode: 'virtual' } }, (height && { style: { height: height } }), { onToolbarPreparing: onToolbarPreparing, allowColumnReordering: true, allowColumnResizing: true, columnAutoWidth: true }),
                React.createElement(Template, { name: "exportCsv", render: renderExportBtn }),
                React.createElement(Template, { name: "refreshData", render: renderRefreshBtn }),
                React.createElement(Template, { name: "resultsCounter", render: renderResultsCounter }),
                React.createElement(Template, { name: "filterFields", render: renderFilterFields }),
                React.createElement(SearchPanel, { visible: true, highlightSearchText: false }),
                React.createElement(FilterRow, { visible: false }),
                columns.map(function (column, idx) {
                    return (React.createElement(Column, __assign({ key: column.field + "-" + column.cellType, dataField: column.field }, column, { visible: phoneView ? column === null || column === void 0 ? void 0 : column.isMobileView : !(column === null || column === void 0 ? void 0 : column.isMobileView), cellRender: function (_a) {
                            var row = _a.row;
                            return (React.createElement(ChangelogCell, __assign({ data: row.data, metadata: config.metadata[idx], timeZone: timeZone }, column)));
                        } })));
                })))));
}
;
//# sourceMappingURL=ChangelogTable.js.map